import React from 'react';
import { NavLink } from 'react-router-dom';
import ENUMS from '../../enums';
import { enumHelper } from '../../utils';

export const salesList = [
  {
    title: 'ردیف',
    dataIndex: 'num',
    isRowNumber: true,
  },
  {
    title: 'نام کافه',
    dataIndex: 'name',
    name: 'name',
    isSortable: false,
  },
  {
    title: 'تاریخ رزرو',
    dataIndex: 'date',
    name: 'date',
    isSortable: true,
  },
  {
    title: 'زمان شروع رزرو',
    dataIndex: 'startAt',
    name: 'startAt',
    isSortable: false,
  },
  {
    title: 'زمان پایان رزرو',
    dataIndex: 'endAt',
    name: 'endAt',
    isSortable: false,
  },
  {
    title: 'کد پیگیری رزرو',
    dataIndex: 'trackingNumber',
    name: 'trackingNumber',
    isSortable: false,
  },
  {
    title: 'میز',
    dataIndex: 'reservedTables',
    render: value =>
      value?.map(
        (ele, index, self) =>
          ` ${ele.num} ${index < self.length - 1 ? '،' : ''}`,
      ),
  },
  {
    title: 'تعداد افراد',
    dataIndex: 'persons',
    name: 'persons',
    isSortable: false,
  },
  {
    title: 'صندوق',
    dataIndex: 'toBePaidToCafePrice',
    name: 'toBePaidToCafePrice',
    isSortable: false,
    render: text => (
      <div className={`direction-ltr`}>{Number(text).toLocaleString()}</div>
    ),
  },
  {
    title: 'طلب از آرسی',
    dataIndex: 'balanceAmount',
    name: 'balanceAmount',
    isSortable: false,
    render: text => (
      <div className={`direction-ltr`}>{Number(text).toLocaleString()}</div>
    ),
  },
  {
    title: 'سهم کافه',
    dataIndex: 'cafeShare',
    name: 'cafeShare',
    isSortable: false,
    render: cafeShare => (
      <div className={`direction-ltr`}>
        {Number(cafeShare).toLocaleString()}
      </div>
    ),
  },
  {
    title: 'سهم آرسی',
    dataIndex: 'rseeStockAmount',
    name: 'rseeStockAmount',
    isSortable: false,
    render: text => (
      <div className={`direction-ltr`}>{Number(text).toLocaleString()}</div>
    ),
  },
  {
    title: 'جمع کل فاکتور',
    dataIndex: 'totalFactorAmount',
    name: 'totalFactorAmount',
    isSortable: false,
    render: text => (
      <div className={`direction-ltr`}>{Number(text).toLocaleString()}</div>
    ),
  },
  {
    title: 'وضعیت ',
    dataIndex: 'status',
    name: 'status',
    isSortable: false,
    render: text =>
      text && (
        <span
          className='badge badge-secondary'
          style={{
            backgroundColor: `${ENUMS.SHEMATIC_RESERVATION.badgeColors[text]}`,
          }}
        >
          {enumHelper.convertEnumValueToTitle(
            ENUMS.CAFE_RESERVATION.list,
            text,
          )}
        </span>
      ),
  },
];
